const commonAndMisc = {
  errorMessage404: "앗! 찾으시는 페이지가 존재하지 않습니다.", // translated
  errorContentUnavailable: "죄송합니다! 찾으시는 콘텐츠가 없습니다. 문제에 대해 문의해 주세요.", // translated
  backToHome: "홈으로 돌아가기", // translated
  information: "정보", // translated
  additionalInformation: "추가 정보", // translated
  destinationPlaceholder: "어디 가세요", // translated
  aboutUs: "회사 소개", // translated
  pleaseWait: "기다리세요...", // translated
  featuredHotels: "추천 호텔", // translated
  topPackages: "최고 패키지", // translated
  topTours: "탑 투어", // translated
  traveller: "여행자", // translated
  reviews: "리뷰", // translated
  home: "집", // translated
  packages: "패키지", // translated
  experiences: "경험담", // translated
  close: "닫다", // translated
  loadingMessage: "최적의 가격을 찾아보는 동안 잠시 기다려 주십시오.", // translated
  loadingMessageTheHotelCo: "최적의 가격을 찾아보는 동안 잠시 기다려 주십시오.", // translated
  loadingMessageSearchStrip: "최저가를 검색하는 동안 잠시 기다려주세요...", // translated

  stillSearchingHotels: "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "꼭 방문해야 할 국가", // translated
  profile: "프로필", // translated
  reservations: "전세", // translated
  myBookings: "내 예약", // translated
  address: "주소", // translated
  firstName: "이름", // translated
  lastName: "성", // translated
  email: "이메일", // translated
  login: "로그인", // translated
  logout: "로그아웃", // translated
  myProfile: "내 프로필", // translated
  myAccount: "내 계정", // translated
  myPoints: "내 의견", // translated
  myQuotations: "내 견적", // translated
  myChatRooms: "내 채팅", // translated
  chatRoomsListEmpty: "이 계정에는 채팅방이 없습니다.", // translated
  chatRoomsOpen: "열려 있는", // translated
  chatRoomsLastActivity: "최근 활동", // translated
  chatRoomsUnread: "읽히지 않는", // translated
  chatRoomsBadgeQuotation: "인용", // translated
  chatRoomsBadgeTripOffer: "여행 상품", // translated
  chatRoomsOpenQuotationAria: "견적 문의 채팅: {{name}}", // translated
  chatRoomsOpenTripOfferAria: "여행 제안 채팅: {{name}}", // translated
  chatRoomsOpenGenericAria: "채팅방 열기: {{name}}", // translated
  quotationChatInvalidLink:
    "채팅 링크가 잘못되었습니다. 프로필 또는 견적 목록에서 채팅을 열거나, room_code 또는 room_uid 중 하나만 사용하세요.", // translated
  quotationChatNoTripDetails: "이 채팅에서는 여행 세부 정보를 확인할 수 없습니다.", // translated
  chat: "채팅", // translated
  verified: "확인됨", // translated
  unverified: "미확인", // translated
  selectLanguage: "언어를 선택하세요", // translated
  selectCurrency: "통화를 선택하세요", // translated
  upgrade: "치받이", // translated
  membership: "멤버십", // translated
  travelTrust: "여행 신탁", // translated
  signInUp: "로그인/가입", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "전 세계 호텔 및 리조트를 놀라운 도매가로 만나보세요", // translated
  dashboard: "계기반", // translated
  pricing: "가격", // translated
  refundable: "환불 가능", // translated
  cars: "자동차", // translated
  cruises: "크루즈", // translated
  view: "보다", // translated
  price: "가격", // translated
  totalPrice: "총 가격", // translated
  filterRoomName: "필터 룸 이름", // translated
  get: "얻다", // translated
  guestInformationValidation: "고객 정보 확인", // translated
  reservation: "예약", // translated
  checkIn: "체크인", // translated
  checkOut: "체크아웃", // translated
  paymentInitiattionErroeMessage: "결제 절차를 시작할 수 없었습니다. 불편을 드려 죄송합니다.", // translated
  warning: "경고", // translated
  couldNotFindPriceForDateWarning:
    "해당 날짜의 가격 정보를 찾을 수 없습니다. 다른 날짜로 다시 시도해 주세요.", // translated
  searchFormValidationError: "검색 양식 유효성 검사 오류", // translated
  pleaseSelectValidDateFirst: "먼저 유효한 날짜를 선택해 주세요.", // translated
  searchError: "검색 오류", // translated
  priceSearchInitiationError:
    "가격 검색 프로세스를 시작할 수 없었습니다. 나중에 다시 시도해 주세요. 불편을 드려 죄송합니다.", // translated
  searchWarning: "검색 경고", // translated
  couldNotFindPriceAndOrAvailability:
    "요청하신 상품의 가격 및/또는 재고 정보를 찾을 수 없었습니다. 불편을 드려 죄송합니다.", // translated
  joinNow: "지금 가입하세요", // translated
  signIn: "로그인", // translated
  searchNow: "지금 검색하세요", // translated
  bookingFailed: "예약 실패", // translated
  sorryForTheInconvenience: "불편을 드려 죄송합니다.", // translated
  contactUsToAssistWithYourBooking:
    "예약 관련 문의는 저희에게 연락 주시기 바랍니다. 불편을 드려 죄송합니다.", // translated
  paymentFailedTryAgain: "결제에 실패했습니다. 다시 시도해 주세요.", // translated
  quickLinks: "바로가기 링크", // translated
  tours: "투어", // translated
  termsAndConditions: "이용약관", // translated
  pleaseWaitWhileInitiatingPayment: "결제 절차를 시작하는 동안 잠시 기다려 주십시오.", // translated
  back: "뒤쪽에", // translated
  nextStep: "다음 단계", // translated
  book: "책", // translated
  checkout: "점검", // translated
  specifyPickUpPoint: "원하시는 픽업 장소를 지정해 주세요.", // translated
  pickupPoint: "픽업 장소", // translated
  optional: "선택 과목", // translated
  provideImportantInfoForYourTravel: "여행 중에 중요할 만한 정보가 있으면 알려주세요.", // translated
  remarks: "비고", // translated
  travellerInformation: "여행자 정보", // translated
  bookingRemarks: "예약 관련 비고", // translated
  bookingOverview: "예약 개요", // translated
  paymentFailed: "결제 실패", // translated
  paymentSuccess: "결제 성공", // translated
  at: "~에", // At date // translated
  on: "~에", // on date // translated
  person: "사람", // translated
  cancellationPolicy: "취소 정책", // translated
  From: "에서", // translated
  to: "에게", // translated
  cancellationIs: "취소는", // translated
  pickup: "찾다", // translated
  flights: "항공편", // translated
  Accommodation: "숙소", // translated
  payAndBook: "결제 및 예약", // translated
  onRequest: "요청 시", // translated
  weAreFindingTheBestAvailableServices: "우리는 이용 가능한 최상의 서비스를 찾고 있습니다.", // translated
  withTheBestAvailablePrices: "최상의 가격으로", // translated
  inRealTime: "실시간으로", // translated
  seconds: "초", // translated
  thisProcessCanTakeUpToOneMinute: "이 과정은 최대 1분 정도 소요될 수 있습니다.", // translated
  pleaseDoNotRefreshThisPage: "이 페이지를 새로고침하지 마세요.", // translated
  wellItSeemsItCanTakeBitLonger: "음... 시간이 좀 더 걸릴 것 같네요.", // translated
  yourBrowserDoesNotSupportTheVideoTag: "사용하시는 브라우저는 비디오 태그를 지원하지 않습니다.", // translated
  bookingSuccess: "예약 성공", // translated
  bookingReference: "예약 번호", // translated
  referenceCopied: "참조 복사됨", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "곧 예약에 필요한 모든 정보가 담긴 이메일을 받으실 겁니다.", // translated
  viewMore: "더 보기", // translated
  readMore: "더 읽어보기", // translated
  customerSupport: "고객 지원", // translated
  socialMedia: "소셜 미디어", // translated
  hours: "시간", // translated
  hour: "시간", // translated
  minutes: "분", // translated
  minute: "분", // translated
  memberId: "회원 ID", // translated
  star: "별", // translated
  stars: "별들", // translated
  proceed: "진행하다", // translated
  clearAllFilters: "모든 필터 지우기", // translated
  clearYourFilters: "결과를 보려면 필터 옵션을 지우세요.", // translated
  noOptionsForSelectedFilters: "필터 조건에 맞는 옵션이 없습니다.", // translated
  privacyPolicy: "개인정보 보호정책", // translated
  security: "보안", // translated
  nearby: "가까운", // translated
  distanceFromSelection: "선택 지점으로부터의 거리", // translated
  km: "km", // translated
  restaurants: "레스토랑", // translated
  active: "활동적인", // translated
  visitSite: "사이트 방문하기", // translated
  score: "점수", // translated
  applicationAvailable: "지원 가능", // translated
  sendUsEmail: "저희에게 이메일을 보내주세요", // translated
  sendUsYourRequest: "요청사항을 보내주세요", // translated
  notAvailable: "이용 불가", // translated
  found: "설립하다", // translated
  progressAt: "진행 상황", // translated
  currency: "통화", // translated
  sendUsRequest: "요청사항을 보내주세요", // translated
  noReservationsForThisProduct: "이 상품은 예약이 불가능합니다.", // translated
  noBookingsForThisProduct: "이 상품은 예약이 없습니다.", // translated
  noReservationsOfThisProduct: "이 상품 유형은 예약이 불가능합니다.", // translated
  actions: "행위", // translated
  save: "구하다", // translated
  confirmed: "확인됨", // translated
  cancelled: "취소", // translated
  pending: "보류 중", // translated
  notConfirmed: "아직 확인되지 않음", // translated
  status: "상태", // translated
  reference: "참조", // translated
  leadGuest: "주요 게스트", // translated
  sendVoucherEmail: "바우처 이메일 발송", // translated
  sendCancellationEmail: "취소 이메일 보내기", // translated
  downloadVoucher: "다운로드 바우처", // translated
  emailHasBeenSent: "이메일이 성공적으로 전송되었습니다.", // translated
  emailNotSentTryAgain: "이메일이 전송되지 않았습니다! 다시 시도해 주세요.", // translated
  titleIsRequired: "제목을 입력해야 합니다.", // translated
  genderIsRequired: "성별 정보가 필요합니다.", // translated
  firstNameMustContainAlphabetic: "이름은 반드시 알파벳으로만 구성되어야 합니다.", // translated
  firstNameIsRequired: "이름은 필수 입력 사항입니다.", // translated
  lastNameIsRequired: "성(姓)은 필수 입력 사항입니다.", // translated
  lastNameMustContainAlphabetic: "성에는 알파벳만 포함되어야 합니다.", // translated
  phoneNumberInTheFormat: "전화번호는 공백 없이 올바른 형식이어야 합니다.", // translated
  phoneNumberIsRequired: "전화번호는 필수입니다.", // translated
  emailIsRequired: "이메일 주소는 필수입니다.", // translated
  invalidEmail: "잘못된 이메일 주소입니다.", // translated
  addressIsRequired: "주소는 필수 입력 사항입니다.", // translated
  cityIsRequired: "도시가 필요합니다", // translated
  postalCodeIsRequired: "우편번호는 필수 입력 사항입니다.", // translated
  countryIsRequired: "국가를 입력해야 합니다.", // translated
  yourReservationIsInProgress: "예약이 진행 중입니다", // translated
  yourReservationHasBeenRegistered: "고객님의 예약이 등록되었습니다.", // translated
  clickHere: "여기를 클릭하세요", // translated
  iHaveReadAgreeWithAbove: "저는 위 내용을 읽었고 동의합니다.", // translated
  pleaseCheckTheBox:
    "다음 단계로 진행하기 전에 제공된 정보를 읽고 동의한다는 의미로 하단의 확인란을 체크해 주세요.", // translated
  pleaseAcceptProperty:
    "예약하시는 숙소가 원하시는 숙소임을 나타내기 위해 상단의 체크박스를 선택해 주세요.", // translated
  ourContactNumbersAre: "저희 연락처는 다음과 같습니다.", // translated
  operationalHours: "운영 시간", // translated
  monday: "월요일", // translated
  tuesday: "화요일", // translated
  wednesday: "수요일", // translated
  thursday: "목요일", // translated
  friday: "금요일", // translated
  saturday: "토요일", // translated
  sunday: "일요일", // translated
  monday_to_friday: "월요일부터 금요일까지", // translated
  closed: "닫은", // translated
  topUpPoints: "포인트 충전", // translated
  gender: "성별", // translated
  nationality: "국적", // translated
  amountIn: "금액", // translated
  amountOut: "금액 지급", // translated
  maintenanceTitle: "웹사이트 점검 중입니다", // translated
  maintenanceDescription: "정기 점검을 진행 중입니다. 잠시 후 다시 접속해 주세요.", // translated
  maintenanceCountdownLabel: "남은 예상 시간", // translated
  maintenanceLogoAlt: "웹사이트 로고", // translated
  maintenanceDays: "날", // translated
  maintenanceHours: "영업시간", // translated
  maintenanceMinutes: "분", // translated
  maintenanceSeconds: "초", // translated
  maintenanceStatusBadge: "정기 유지보수", // translated
  maintenanceRefresh: "페이지 새로고침", // translated
  maintenanceExpired: "점검이 곧 완료될 예정입니다. 페이지를 새로고침해 주세요.", // translated
};

export default commonAndMisc;
